import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useI18n } from "../i18n";
import { hubTabsFor } from "../constants/navigation";

/**
 * The tabs of a drawer entry that stands for several screens (Supply,
 * Mixing). Each screen is still its own route; this only ties them together.
 * With a single tab left — a module switched off — there is nothing to choose.
 */
const HubTabs = ({ offered }) => {
  const { t } = useI18n();
  const { pathname } = useLocation();
  const tabs = hubTabsFor(pathname, offered);

  if (tabs.length < 2) return null;

  return (
    <nav
      className="mb-4 flex gap-2 overflow-x-auto"
      aria-label={t(`nav.hubs.${tabs[0].hub}`)}
    >
      {tabs.map((tab) => {
        const active = pathname.startsWith(tab.path);
        return (
          <Link
            key={tab.key}
            to={tab.path}
            aria-current={active ? "page" : undefined}
            className={`shrink-0 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
              active
                ? "bg-primary-600 text-white shadow"
                : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-200"
            }`}
          >
            <span className="me-2">{tab.icon}</span>
            {t(`nav.${tab.key}`)}
          </Link>
        );
      })}
    </nav>
  );
};

export default HubTabs;
